import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Hook for deleting an assessment
 */
export const useDeleteAssessment = () => {
  const { openToast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (assessmentId: string) => {
      const response = await apiClient.delete(
        `/assessment/jobs/${assessmentId}/`
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        type: 'success',
        show: true,
        heading: 'Success',
        text: 'Assessment deleted successfully',
      });
      // Invalidate and refetch jobs list
      queryClient.invalidateQueries({ queryKey: ['manageJobs'] });
      queryClient.invalidateQueries({ queryKey: ['manageJobsCounts'] });
    },
    onError: (error: any) => {
      openToast({
        type: 'error',
        show: true,
        heading: 'Error',
        text: error?.response?.data?.message || 'Failed to delete assessment',
      });
    },
  });

  return {
    deleteAssessment: mutation.mutate,
    isLoading: mutation.isPending,
  };
};
